// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarColaboradorResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/colaboradores/migrar
 * (controllers/migration/colaboradores.php::migrar).
 *
 * O resultado da carga de UM colaborador. `dados` e o desfecho DIRETO — a
 * propria linha, sem chave embrulhando — porque nao ha nada alem dele a
 * carregar nesta resposta.
 *
 * A forma mora em `Migration_ColaboradorResultadoRow`, e nao aqui, de proposito:
 * a MESMA linha e cada item de `resultados` na carga em lote. Declarar os oito
 * campos duas vezes criaria duas verdades sobre o mesmo desfecho, e elas
 * divergiriam no primeiro campo novo.
 */
import type { Migration_ColaboradorResultadoRow } from './Migration_ColaboradorResultadoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Migration_MigrarColaboradorResponseDados = Migration_ColaboradorResultadoRow;

export type Migration_MigrarColaboradorResponse = ApiResponse<Migration_MigrarColaboradorResponseDados>;

registerResponseContract('Migration_MigrarColaboradorResponse', {
  zoho_id:  { type: 'string',  required: false },
  nome:     { type: 'string',  required: false },
  email:    { type: 'string',  required: false },
  status:   { type: 'string',  required: false },
  run_id:   { type: 'number',  required: false },
  sub:      { type: 'string',  required: false },
  blockers: {
    type: 'array',
    required: false,
    items: {
      code:     { type: 'string',  required: false },
      message:  { type: 'string',  required: false },
      severity: { type: 'string',  required: false },
      entity:   { type: 'string',  required: false },
      zoho_id:  { type: 'string',  required: false },
      label:    { type: 'string',  required: false },
    },
  },
  erro:     { type: 'string',  required: false },
})
